export default __webpack_public_path__ + "static/media/gray2-star.b10e1841.svg";